import Vue            from 'vue'
import VueRouter      from 'vue-router'
import Home           from '../views/Home.vue'
import Covid19        from '../views/Covid19.vue'
import Help           from '../views/Help.vue'
import Contact        from '../views/Contact.vue'
import Terms          from '../views/Terms.vue'
import RentTerms      from '../views/RentTerms.vue'
import Cookies        from '../views/Cookies.vue'
import Promo          from '../views/Promo.vue'
import Leasing        from '../views/Leasing.vue'
import Reservestep3   from '../views/Reservestep3.vue'
import Reservestep4   from '../views/Reservestep4.vue'
import Reservestep5   from '../views/Reservestep5.vue'
import Locations      from '../views/Locations.vue'
import Office         from '../views/Office.vue'
import Privacy        from '../views/Privacy.vue'
import Fleet          from '../views/Fleet.vue'
import Panel          from '../views/Panel.vue'
import Maintenance    from '../views/Maintenance.vue'
import Weekend        from '../views/promodetails/Weekend.vue'
import Greenweek      from '../views/promodetails/Greenweek.vue'
import Twoonefree     from '../views/promodetails/Twoonefree.vue'
import Pack3d         from '../views/promodetails/Pack3d.vue'
import Pack4d         from '../views/promodetails/Pack4d.vue'
import Bymonth        from '../views/promodetails/Bymonth.vue'
import ReserveDateTime      from '../views/ReserveDateTime.vue'
import reserveFinalStep     from '../views/reserveFinalStep.vue'
import ModifyViewDetails    from '../views/ModifyViewDetails'
import i18n from '../i18n'
import store from '../store'
/* test rollback */
Vue.use(VueRouter)
/* rollback1 */
const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },

  {
  path: '/:lang',
  component: {
    render (c) { return c('router-view') },
  },

  children: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: 'maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: 'promodetails/weekend',
      name: 'Weekend',
      component: Weekend
    },
    {
      path: 'promodetails/greenweek',
      name: 'Greenweek',
      component: Greenweek
    },
    {
      path: 'promodetails/twoonefree',
      name: 'Twoonefree',
      component: Twoonefree
    },
    {
      path: 'promodetails/pack3d',
      name: 'Pack3d',
      component: Pack3d
    },
    {
      path: 'promodetails/pack4d',
      name: 'Pack4d',
      component: Pack4d
    },
    {
      path: 'promodetails/bymonth',
      name: 'Bymonth',
      component: Bymonth
    },
    {
      path: 'fleet',
      name: 'Fleet',
      component: Fleet
    },
    {
      path: 'covid19',
      name: 'Covid19',
      component: Covid19
    },
    {
      path: 'help',
      name: 'Help',
      component: Help
    },
    {
      path: 'contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: 'terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: 'rentterms',
      name: 'RentTerms',
      component: RentTerms
    },
    {
      path: 'cookies',
      name: 'Cookies',
      component: Cookies
    },
    {
      path: 'promo',
      name: 'Promo',
      component: Promo
    },
    {
      path: 'leasing',
      name: 'Leasing',
      component: Leasing
    },
    {
      path: 'reservestep3',
      name: 'Reservestep3',
      component: Reservestep3
    },
    {
      path: 'reservestep4',
      name: 'Reservestep4',
      component: Reservestep4
    },
    {
      path: 'reservestep5',
      name: 'Reservestep5',
      component: Reservestep5
    },
    {
      path: 'reservedatetime',
      name: 'ReserveDateTime',
      component: ReserveDateTime
    },
    {
      path: 'reserve_confirmation',
      name: 'reserveFinalStep',
      component: reserveFinalStep
    },
    {
      path: 'locations',
      name: 'Locations',
      component: Locations
    },
    {
      path: 'office',
      name: 'Office',
      component: Office
    },
    {
      path: 'panel',
      name: 'Panel',
      component: Panel,
      meta: { requiresAuth: true }
    },
    {
      path: 'privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: 'about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
  
    // rutas proceso modificar reserva
    {
      path:'details',
      name: 'details',
      component: ModifyViewDetails
    },
    {
      path:'modificar-reserva',
      name: 'modificarReserva',
      component: () => import('../views/ModifyReserve.vue')
    },
    {
      path:'promocion-especial/:id/:marca/:modelo',
      name: 'promoes',
      component: () => import('../views/promodetails/promocion_especial.vue')
    },
    {
      path:'login',
      name: 'login',
      component: () => import('../views/Login.vue')
    },
    {
      path:'registro',
      name: 'registro',
      component: () => import('../views/Register.vue')
    },
    {
      path:'recuperar-password',
      name: 'recuperar-password',
      component: () => import('../views/recuperar-password.vue')
    },
    {
      path: 'formulario-password/:token',
      name:'form-password',
      component: function () {
        return import(/* webpackChunkName: "formulario-password" */ '../views/formulario-password.vue')
      },
    },
    {
      path: 'verify-email/:url',
      component: function () {
        return import(/* webpackChunkName: "formulario-password" */ '../views/verify_email.vue')
      },
    },
    {
      path:'perfil',
      name: 'perfil',
      component: () => import('../views/Perfil.vue'),
      meta: { requiresAuth: true }
    },
    {
      path:'test',
      name: 'test',
      component: () => import('../views/Test.vue'),
      //meta: { requiresAuth: true }
    },
    {
      path:'home2',
      name: 'home2',
      component: () => import('../views/Home2.vue'),
      //meta: { requiresAuth: true }
    },
    {
      path:'eske',
      name: 'eske',
      component: () => import('../views/SkeletonFleet.vue'),
      //meta: { requiresAuth: true }
    },
    {
      path:'international-destination',
      name: 'international-destination',
      component: () => import('../views/InternationalDestination.vue'),
      //meta: { requiresAuth: true }
    }
  ]
}
]

const router = new VueRouter({
  /* This scroll links views on top */
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  //routing i18n config
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  let language = to.params.lang;
  
  if (!language){

    next({path: '/es'})
    
  }
  
  i18n.locale = language
  next()


});

router.beforeEach((to, from, next) => {

 
  if (to.matched.some(record => record.meta.requireAuth) && !store.getters['autenticacion/isAuth']) {

    next({ name: 'home'})
    
  }
  else if(to.matched.some(record => record.meta.guest) && store.getters['autenticacion/isAuth'])
  {
    next()
  }
  else {
    next()
  }
})

export default router

